import { AxiosInstance, AxiosRequestConfig } from 'axios';

import {
  PostAdvancedHuntingStrategyRequestPayload,
  PostStrategyRequestPayload,
  RequestPayload,
  SearchPointsRequestPayload,
} from './types';
const ENDPOINT = 'strategies/';

// eslint-disable-next-line import/no-anonymous-default-export
export default (instance: AxiosInstance, config: AxiosRequestConfig) => ({
  getStrategies: (payload: RequestPayload) =>
    instance.post(ENDPOINT, payload, config),
  getPoints: (payload: SearchPointsRequestPayload) =>
    instance.post(ENDPOINT + 'points_around/', payload, config),
  getAvailableUsers: () => instance.get(ENDPOINT + 'available_users/', config),
  postStrategy: (payload: PostStrategyRequestPayload) =>
    instance.post(ENDPOINT + 'create/', payload, config),
  updateStrategy: (payload: Partial<PostStrategyRequestPayload>) =>
    instance.post(ENDPOINT + 'update/', payload, config),
  updateStrategyAdvanced: (
    payload: Partial<PostAdvancedHuntingStrategyRequestPayload>
  ) => instance.post(ENDPOINT + 'update/advanced/', payload, config),
});
